import React, { useEffect, useRef, useState } from "react";
import {
  edit_icon,

} from "../../assets/imgs";
import { useNavigate } from "react-router-dom";
import { Modal } from "react-bootstrap";
import DatePicker from "react-datepicker";
import CloseIcon from "@mui/icons-material/Close";
import {
  useLazyPropertiesViewQuery,
  usePropertiesRoomAvailableMutation,
  usePropertiesRoomBlockMutation,
} from "../../screens/redux/api/api";
import moment from "moment/moment";
import { toast } from "react-toastify";

const PropertyRooms = ({ setTabs, data }) => {
  // RTK QUERY
  const [ViewPropertyApi] = useLazyPropertiesViewQuery();
  const [propertiesRoomAvailableApi] = usePropertiesRoomAvailableMutation();
  const [propertiesRoomBlockApi] = usePropertiesRoomBlockMutation();

  const [value, setValue] = useState();
  const navigate = useNavigate();
  const [image, setImage] = useState();
  const [show, setShow] = useState(false);
  const [blockTabs, setBlockTabs] = useState(1);
  const [rooms, setRooms] = useState([]);
  const [catIds, setCatIds] = useState([]);
  const [roomDetails, setRoomDetails] = useState({});

  const [category, setCategory] = useState([]);

  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [minDate, setMinDate] = useState(new Date());
  const [maxDate, setMaxDate] = useState("");
  const [roomAvailableList, setRoomAvailableList] = useState([]);

  const areDatesSame = (date1, date2) => {
    const d1 = new Date(date1);
    const d2 = new Date(date2);

    return (
      d1.getFullYear() === d2.getFullYear() &&
      d1.getMonth() === d2.getMonth() &&
      d1.getDate() === d2.getDate()
    );
    // return (
    //   new Date(date1).toISOString().split("T")[0] ===
    //   new Date(date2).toISOString().split("T")[0]
    // );
  };

  const getDayBefore = (dateInput) => {
    const date = new Date(dateInput);
    date.setDate(date.getDate() - 1);
    return date.toISOString().split("T")[0];
  };

  const onChange = (dates) => {
    const [start, end] = dates;

    // CHECKING IF SELECED DATE IS SAME
    let sameDate = areDatesSame(start, end);

    if (sameDate) {
      setMinDate(new Date());
      setMaxDate("");
    } else {
      setMinDate(moment(start).format("YYYY/MM/DD"));
      setMaxDate("");
    }

    setStartDate(start);
    setEndDate(end);
    // "2025/04/28" format
  };

  // console.log("roomDetails", roomDetails);

  const handleClose = () => {
    setRoomDetails({});
    setRoomAvailableList([]);
    setMinDate(new Date());
    setMaxDate("");
    setStartDate(null);
    setEndDate(null);
    setShow(false);
  };

  const handleShow = (item) => {
    setRoomDetails(item);
    setShow(true);
  };

  const roomAvailable = () => {
    if (!startDate) {
      toast.error("Please Enter Date to Block")
      return
    }
    let formdata = new FormData();
    formdata.append("property_id", data?.data?.id);
    formdata.append("property_room_id", roomDetails?.id);
    formdata.append("room_category_id", roomDetails?.room_category_id);
    formdata.append("from_date", moment(startDate).format("YYYY-MM-DD"));
    if (endDate != null) {
      formdata.append("to_date", moment(endDate).format("YYYY-MM-DD"));
    } else {
      formdata.append("to_date", moment(startDate).format("YYYY-MM-DD"));
    }
    formdata.append("req_type", 3);

    propertiesRoomAvailableApi(formdata)
      .unwrap()
      .then((res) => {
        if (res?.status == "success") {
          let temp = [];

          res?.data?.dates?.map((item, ind) => {
            temp.push({
              ...item,
              block_rooms: '',
            });
          });
          setRoomAvailableList(temp);
          setBlockTabs(2);
          toast.success(res?.message);
        } else {
          toast.error(res?.message);
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  const handleBlockChange = (event, ind) => {
    let temp = [...roomAvailableList];
    temp[ind] = {
      ...temp[ind],
      block_rooms: event,
    };
    setRoomAvailableList(temp);
  };

  const roomBlock = () => {

    if (!roomAvailableList || roomAvailableList.length === 0) {
      toast.error("No room availability data provided");
      return;
    }
    if (!data?.data?.id || !roomDetails?.id || !roomDetails?.room_category_id) {
      toast.error("Missing required property or room information");
      return;
    }

    let formdata = new FormData();
    formdata.append("property_id", data?.data?.id);
    formdata.append("property_room_id", roomDetails?.id);
    formdata.append("room_category_id", roomDetails?.room_category_id);
    formdata.append("from_date", moment(startDate).format("YYYY-MM-DD"));
    if (endDate != null) {
      formdata.append("to_date", moment(endDate).format("YYYY-MM-DD"));
    } else {
      formdata.append("to_date", moment(startDate).format("YYYY-MM-DD"));
    }
    formdata.append("block_type", 3);

    let count = 1;
    let count_ = 1;

    let roomAvailableList_ = []   

    roomAvailableList?.map((item, ind) => {
      let block_rooms_ = item?.block_rooms ? +item?.block_rooms : 0
      if(block_rooms_ > 0){
       roomAvailableList_.push(item)
      }
    })

    roomAvailableList_?.map((item, ind) => {
       let block_rooms_ = item?.block_rooms ? +item?.block_rooms : 0
      if (block_rooms_ > item?.available) {
        count = count + 1;
      }
      

      if (block_rooms_ < 0) {
        count = count + 1;
        count_ = count_ + 1;
      }
      

      formdata.append(`blocked_dates[${ind}][for_date]`, item?.date);
      formdata.append(
        `blocked_dates[${ind}][blocked_rooms]`,
        item?.block_rooms
      );
    });

    if (count == 1) {
      propertiesRoomBlockApi(formdata)
        .unwrap()
        .then((res) => {
          if (res?.status == "success") {
            handleClose();
            getList(data?.data?.id);
            toast.success(res?.message);
          } else {
            toast.error(res?.message);
          }
        })
        .catch((err) => {
          console.log("err", err);
        });
    } else if (count_ > 1) {
      toast.error("Blocked Rooms field must be at least 1");
    }
  };

  // console.log(data?.data?.id, 'room_data')

  const getList = (id) => {
    ViewPropertyApi(id)
      .then((res) => {
        setRooms(res?.data?.data?.rooms);

        let temp = res?.data?.data?.rooms?.map(
          (item) => item?.room_category_id
        );
        setCatIds(temp);

        setCategory(res?.data?.data?.rooms?.map((item) => item?.category));
      })
      .catch((err) => {
        console.log("err", err);
      });
  };
  // console.log('temp', category)

  // console.log("rooms", rooms?.[0]?.id);
  // console.log("catsId", catIds);

  useEffect(() => {
    if (data?.data?.id) {
      getList(data?.data?.id);
    }
  }, []);

  const clearBtn = () => {
    setMinDate(new Date());
    setMaxDate("");
    setStartDate(null);
    setEndDate(null);
  };

  return (
    <div>
      <Modal show={show} onHide={handleClose} centered>
        <div className="p-4">
          <div className="d-flex ac-jb">
            <h2 className="f3 fs-sm-18 fs-md-20 fs-lg-22 fs-xl-24 fs-xxl-22 sec mb-0">
              Block
            </h2>
            <button
              className="border-0 bg-transparent"
              onClick={() => handleClose()}
            >
              <CloseIcon />
            </button>
          </div>
          {blockTabs == 1 && (
            <div className="mt-4">
              <div className="">
                <h2 className="f3 fs-sm-18 fs-md-20 fs-lg-22 fs-xl-24 fs-xxl-22  text-center">
                  Select Dates to block
                </h2>
                {startDate != null && (
                  <div className="text-end">
                    <button className="cust-btn" onClick={() => clearBtn()}>
                      Clear
                    </button>
                  </div>
                )}
                <div className="text-center">
                  <DatePicker
                    selected={startDate}
                    onChange={onChange}
                    startDate={startDate}
                    endDate={endDate}
                    selectsRange
                    selectsDisabledDaysInRange
                    minDate={minDate}
                    maxDate={maxDate}
                    inline
                  // excludeDates={[
                  //   new Date("2025-04-22"),
                  //   new Date("2025-04-27"),
                  // ]}
                  />
                </div>
              </div>
              <div className="col-md-12 d-flex ac-jc mt-3">
                <button
                  className="login-btn f2 fs-sm-10 fs-md-10 fs-lg-10 fs-xl-12 fs-xxl-14 mt-3 "
                  // onClick={() => handleClose()}
                  onClick={() => roomAvailable(2)}
                >
                  Next
                </button>
              </div>
            </div>
          )}
          {blockTabs == 2 && (
            <div style={{ maxHeight: "70vh", overflow: "scroll" }}>
              {roomAvailableList?.map((item, ind) => {
                return (
                  <div className="block-box mb-2 m-1 mt-4" key={ind}>
                    <h2 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 ">
                      Date :{" "}
                      {item?.date
                        ? moment(item?.date).format("DD-MM-YYYY")
                        : ""}
                    </h2>
                    <div className="d-flex ac-jb mt-2">
                      <div>
                        <p className="f2 fs-sm-8 fs-md-12 fs-lg-14 fs-xl-14 fs-xxl-15">
                          Available Rooms
                        </p>
                        <input
                          type="number"
                          value={item?.available}
                          disabled
                          className="input-block bg-none "
                          style={{ opacity: "0.5" }}
                        />
                      </div>
                      <div>
                        <p className="f2 fs-sm-8 fs-md-12 fs-lg-14 fs-xl-14 fs-xxl-15">
                          Blocking Rooms
                        </p>
                        <div>
                          <input disabled={item?.available == 0 ? true : false}
                            type="number"
                            onChange={(e) =>
                              handleBlockChange(e.target.value, ind)
                            }
                            value={item?.block_rooms}
                            className="input-block bg-none"
                          />
                          {/* {item?.block_rooms > item?.available && (
                            <p>Max Room: {item?.available}</p>
                          )} */}
                        </div>
                      </div>
                    </div>
                    <div className="d-flex ac-jb">
                      <div className="w-60"></div>
                      <div className="w-50">
                        {item?.block_rooms > item?.available && (
                          <p>Max Room: {item?.available}</p>
                        )}
                      </div>
                    </div>
                  </div>
                );
              })}

              <div className="col-md-12 d-flex ac-jc mt-3">
                <button
                  className="login-btn f2 fs-sm-10 fs-md-10 fs-lg-10 fs-xl-12 fs-xxl-14 mt-3 "
                  onClick={() => roomBlock()}
                >
                  Submit
                </button>
              </div>
            </div>
          )}
        </div>
      </Modal>
      <div className="d-flex ac-je">
        <button
          onClick={() =>
            navigate("/property-room-add", {
              state: {
                id: data?.data?.id,
                catIds: catIds,
              },
            })
          }
          className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 white add-btn"
        >
          + Add
        </button>
      </div>

      {rooms.map((item, index) => {
        return (
          <div className="room-box mt-3 d-flex ac-js gap-4" key={index}>
            <img
              src={item?.images?.[0]?.image}
              style={{ height: "100px", width: "150px", borderRadius: "5px" }}
              alt=""
            />
            <div className="text-center">
              <h4 className="f1 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
                {" "}
                Room Category{" "}
              </h4>
              <p className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 primary mb-0">
                {item?.category?.name}
              </p>
              <button
                onClick={() =>
                  navigate("/property-room-add", {
                    state: {
                      id: data?.data?.id,
                      room_id: item?.id,
                      type: "edit",
                      cat_id: item?.category?.id,
                      catIds: catIds,
                      rooms_id: item?.rooms?.id,
                    },
                  })
                }
                className="cust-btn "
              >
                <img src={edit_icon} alt="" className="mx-2 edit-btn " />
              </button>
            </div>
            <div className="text-center">
              <h4 className="f1 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
                {" "}
                No of Rooms{" "}
              </h4>
              <p className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 primary mb-0">
                {item?.no_of_rooms}
              </p>
              <button
                className="cust-btn susp-btn"
                onClick={() => {
                  handleShow(item);
                  setBlockTabs(1);
                }}
              >
                <p className="mb-0">Block</p>
              </button>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default PropertyRooms;
